import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, Fragment } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import { Image } from "@biocentury/components";
import { urls, socialLinks } from "./urls";
var LOGO_URL = "https://us-west-2-biocentury.graphassets.com/AqjgGpburRt67lm6SEY2Oz/SAQkvq2DQCGorcH4eVaN";
export var Footer = function() {
    var ref = useState([]), openItems = ref[0], setOpenItems = ref[1];
    var toggle = function(item) {
        if (openItems.includes(item)) {
            setOpenItems(openItems.filter(function(key) {
                return key !== item;
            }));
        } else {
            setOpenItems(_to_consumable_array(openItems).concat([
                item
            ]));
        }
    };
    var isOpen = function(item) {
        return openItems.includes(item);
    };
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-primary-500 text-white z-10 lg:px-16 xl:px-40",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 text-sm",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "lg:hidden px-4 py-4",
                    children: Object.keys(urls).map(function(section, index) {
                        return /*#__PURE__*/ _jsx(Fragment, {
                            children: !section ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsxs("div", {
                                className: "grid grid-cols-12 py-2",
                                onClick: function() {
                                    return toggle(section);
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "col-span-11",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "font-light text-lg pb-4",
                                                children: section
                                            }),
                                            isOpen(section) && urls[section].map(function(param, subIndex) {
                                                var title = param.title, href = param.href;
                                                return /*#__PURE__*/ _jsx("div", {
                                                    className: "text-left font-light pl-2 py-2",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        href: href,
                                                        children: title
                                                    })
                                                }, subIndex);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-span-1",
                                        children: isOpen(section) ? /*#__PURE__*/ _jsx(ChevronUpIcon, {
                                            className: "h-5 w-5"
                                        }) : /*#__PURE__*/ _jsx(ChevronDownIcon, {
                                            className: "h-5 w-5"
                                        })
                                    })
                                ]
                            }, index)
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "hidden lg:grid grid-cols-4 py-16",
                    children: Object.keys(urls).map(function(section, index) {
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "col-span-1",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "font-medium pb-4",
                                    children: section
                                }),
                                urls[section].map(function(param, subIndex) {
                                    var title = param.title, href = param.href;
                                    return /*#__PURE__*/ _jsx("div", {
                                        className: "text-left font-light py-1",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            href: href,
                                            children: title
                                        })
                                    }, subIndex);
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-12 px-4 lg:px-0 lg:text-center items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-span-8 pb-4 lg:hidden",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "grid grid-cols-4 gap-0",
                                children: socialLinks.map(function(param, index) {
                                    var title = param.title, href = param.href, icon = param.icon;
                                    return /*#__PURE__*/ _jsx("a", {
                                        href: href,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            src: icon,
                                            alt: title,
                                            width: 32,
                                            height: 32
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-span-12 pb-4 text-left lg:col-span-2 lg:pb-0",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/home",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: LOGO_URL,
                                    alt: "BioCentury",
                                    width: 128,
                                    height: 62
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "block lg:hidden font-light text-xs col-span-12 pb-4 lg:text-sm lg:col-span-8 lg:pb-0",
                            children: /*#__PURE__*/ _jsxs("a", {
                                href: "/privacy-legal/copyright",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " BioCentury Inc. All Rights Reserved."
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden lg:block font-light text-xs col-span-12 pb-4 lg:text-sm lg:col-span-8 lg:pb-0",
                            children: /*#__PURE__*/ _jsxs("a", {
                                href: "/privacy-legal/copyright",
                                children: [
                                    "Copyright \xa9 ",
                                    new Date().getFullYear(),
                                    " BioCentury Inc. All Rights Reserved."
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden col-span-2 lg:block",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "grid grid-cols-4 gap-0",
                                children: socialLinks.map(function(param, index) {
                                    var title = param.title, href = param.href, icon = param.icon;
                                    return /*#__PURE__*/ _jsx("a", {
                                        href: href,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            src: icon,
                                            alt: title,
                                            width: 32,
                                            height: 32
                                        })
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
